import { Injectable } from '@angular/core'
import { map } from 'rxjs'
import { MasterTypeRepository } from 'src/domain/repositories/mastertype.repository'
import { ParentOfMasterTypeEntity } from '../entities/master-type.entity'
import { ParentOfMasterTypeMapper } from '../mappers/master-type/parent-of-master-type.mapper'

@Injectable({
	providedIn: 'root',
})
export class MasterTypeImplementationRepository extends MasterTypeRepository {
	parentOfMasterTypeMapper = new ParentOfMasterTypeMapper()

	GetByTypeParent(params: { id: number }) {
		return this.get<ParentOfMasterTypeEntity[]>('api/MasterTypes/' + params.id + '/ParentOfMasterType').pipe(
			map((response) => {
				return response.map((item) => {
					return this.parentOfMasterTypeMapper.mapFrom(item)
				})
			}),
		)
	}
}
